import {call, type Effect, type ForkEffect, put, select, takeEvery} from "redux-saga/effects";
import {ApiActions} from "@touchnet/react-common";
import {actions} from "~/state/reducers/term-reducer";
import {cast} from "~/utils/fns.ts";
import Selectors from "~/state/selectors.ts";
import TermService from "~/services/term-service";
import {LOG} from "@touchnet/js-utils";

export function* loadTerms(action: ReturnType<typeof actions.loadTerms>): IterableIterator<Effect> {
    yield put(ApiActions.beginApiCall(action.type));

    const cNum: string = cast<string>(yield select(Selectors.getCustomerNumber));
    const serverBase: string = cast<string>(yield select(Selectors.getServerBase));

    try {
        const newTerms = yield call(TermService.autoImport, cNum, serverBase);
        const terms = yield call(TermService.loadTerms, cNum, serverBase);

        if (terms) {
            yield put(actions.receiveTerms(terms));
        }
        if (newTerms) {
            yield put(actions.receiveAutoLoadedTerms(newTerms));
        }
    } catch (error) {
        LOG.error('LOAD_TERMS: Error calling the api %o', [error]);
    }

    yield put(ApiActions.completeApiCall(action.type));
}

export function* forceImportTerms(action: ReturnType<typeof actions.forceImportTerms>): IterableIterator<Effect> {
    yield put(ApiActions.beginApiCall(action.type));

    const cNum: string = cast<string>(yield select(Selectors.getCustomerNumber));
    const serverBase: string = cast<string>(yield select(Selectors.getServerBase));

    try {
        const newTerms = yield call(TermService.forceImport, cNum, serverBase, action.payload);

        if (newTerms) {
            yield put(actions.receiveForcedLoadedTerms(newTerms));
        }
    } catch (error) {
        LOG.error('LOAD_TERMS: Error calling the api %o', [error]);
    }

    yield put(ApiActions.completeApiCall(action.type));
}

export function* updateTerms(action: ReturnType<typeof actions.updateTerms>): IterableIterator<Effect> {
    yield put(ApiActions.beginApiCall(action.type));

    const cNum: string = cast<string>(yield select(Selectors.getCustomerNumber));
    const serverBase: string = cast<string>(yield select(Selectors.getServerBase));

    try {
        const updatedTerms = yield call(TermService.updateTerms, cNum, serverBase, action.payload);

        if (updatedTerms) {
            yield put(actions.receiveUpdatedTerms(updatedTerms));
        }
    } catch (error) {
        LOG.error('UPDATE_TERMS: Error calling the api %o', [error]);
    }

    yield put(ApiActions.completeApiCall(action.type));
}

export default function* rootSaga(): IterableIterator<ForkEffect> {
    yield takeEvery(actions.loadTerms.type, loadTerms);
    yield takeEvery(actions.forceImportTerms.type, forceImportTerms);
    yield takeEvery(actions.updateTerms.type, updateTerms);
}